import { render, staticRenderFns } from "./frontMisRetomasContainer.vue?vue&type=template&id=19226454&scoped=true&"
import script from "./frontMisRetomasContainer.vue?vue&type=script&lang=js&"
export * from "./frontMisRetomasContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19226454",
  null
  
)

export default component.exports